document.addEventListener("DOMContentLoaded", () => {
	const twitterBtn = document.getElementById("twitter-btn");
	const facebookBtn = document.getElementById("facebook-btn");
	const linkedinBtn = document.getElementById("linkedin-btn");

	const pageUrl = document.URL;

	twitterBtn.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
		pageUrl
	)}`;
	facebookBtn.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
		pageUrl
	)}`;
	linkedinBtn.href = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
		pageUrl
	)}`;
});
